import { createSlice } from '@reduxjs/toolkit';

export const calculationSettingsSlice = createSlice({
  name: 'calculationSettings',
  initialState: {
    sections: [],
    overrideReadOnly: false
  },
  reducers: {
    setCalculationSettingsSections: (state, action) => {
      state.sections = action.payload;
    },
    setCalculationOverrideReadOnly: (state, action) => {
      state.overrideReadOnly = action.payload;
    }
  }
});

export const getCalculationSettingsSections = (state) => state.calculationSettings.sections;
export const getCalculationOverrideReadOnly = (state) => state.calculationSettings.overrideReadOnly;

export const { setCalculationSettingsSections, setCalculationOverrideReadOnly } = calculationSettingsSlice.actions;

export default calculationSettingsSlice.reducer;
